import { useEffect } from "react";

let didInit = false;

export default function useGoogleAnalytics() {
  useEffect(() => {
    if (!("initGtm" in window)) return;

    if (!didInit) {
      didInit = true;
      let idleCallbackId = 0;
      const animationFrameId = requestAnimationFrame(() => {
        if ("requestIdleCallback" in window) {
          idleCallbackId = requestIdleCallback(() => {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-expect-error
            initGtm();
          });
        } else {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-expect-error
          initGtm();
        }
      });

      return () => {
        if (idleCallbackId && "cancelIdleCallback" in window) {
          cancelIdleCallback(idleCallbackId);
        }
        cancelAnimationFrame(animationFrameId);
      };
    }
  }, []);
}
